(() => {
  if (window.__LDJ_HERO_VIDEO_LOADED__) return;

  window.__LDJ_HERO_VIDEO_LOADED__ = true;

  const initHero = (section) => {
    if (!section || section.dataset.heroInitialized === 'true') return;

    const video = section.querySelector('[data-hero-video]');
    const button = section.querySelector('[data-hero-sound]');
    const mutedIcon = section.querySelector('[data-icon-muted]');
    const soundIcon = section.querySelector('[data-icon-sound]');

    if (!video || !button) return;

    section.dataset.heroInitialized = 'true';

    /*
     * Always start muted.
     * Sound can only be enabled through the dedicated button.
     */
    video.muted = true;
    video.volume = 1;

    video.play().catch(() => {});

    const updateButton = () => {
      const muted = video.muted;

      button.setAttribute(
        'aria-label',
        muted ? 'Unmute video' : 'Mute video'
      );

      button.setAttribute(
        'aria-pressed',
        muted ? 'false' : 'true'
      );

      if (mutedIcon) {
        mutedIcon.hidden = !muted;
      }

      if (soundIcon) {
        soundIcon.hidden = muted;
      }
    };

    const toggleSound = (event) => {
      event.preventDefault();
      event.stopPropagation();

      video.muted = !video.muted;

      if (!video.muted) {
        video.volume = 1;
        video.play().catch(() => {});
      }

      updateButton();
    };

    button.addEventListener('click', toggleSound);

    updateButton();
  };

  const initAllHeroes = (root = document) => {
    root
      .querySelectorAll('[data-hero-video-section]')
      .forEach(initHero);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initAllHeroes();
    });
  } else {
    initAllHeroes();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAllHeroes(event.target);
  });
})();
